// src/components/SeoHelmet.jsx
import { Helmet } from 'react-helmet-async';

const SeoHelmet = ({
  title = '未経験キャバクラ求人サイト｜New-Nightlife',
  description = '未経験でも安心。LINEで簡単応募＆サポート付き。東京・神奈川・埼玉・千葉エリアで夜職デビューを応援します。',
  url = 'https://new-nightlife.jp/',
  image = 'https://new-nightlife.jp/images/ogp/main.webp',
}) => (
  <Helmet>
    {/* 基本SEO */}
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={url} />

    {/* OGP */}
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="New-Nightlife" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={url} />
    <meta property="og:image" content={image} />
    <meta property="og:image:alt" content="未経験キャバクラ求人LP New-Nightlife トップ画像" />
    <meta property="og:locale" content="ja_JP" />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />

    {/* 構造化データ JSON-LD */}
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: title,
        description,
        url,
        publisher: {
          '@type': 'Organization',
          name: 'New-Nightlife',
          logo: {
            '@type': 'ImageObject',
            url: 'https://new-nightlife.jp/images/logo.webp',
          },
        },
      })}
    </script>
  </Helmet>
);

export default SeoHelmet;
